/*
defines functionality for accessing conceptnet
*/

/**
 * gets a path between the two given concepts in conceptnet,
 * if there is one
 *
 *
 * @param {String} startConcept the phrase to start at
 * @param {String} endConcept the phrase to end at
 * @param {Function} callback the function to call when the server responds
 * @param {boolean} [getAllPaths] (optional) whether to get all paths or one
 */
export function getPathBetweenConcepts(startConcept, endConcept, callback, getAllPaths = true) {
    let driver = neo4j.v1.driver('http://35.196.201.16:7474', neo4j.v1.auth.basic('neo4j', 'neo4j2'));
    let session = driver.session();

    console.log(`trying to connect ${startConcept} and ${endConcept} on conceptnet`);
    console.log(`trying to connect ${startConcept.replace(/[\(\)\.]/, '').split(/W+/)[0]} and ${endConcept.replace(/[\(\)\.]/, '').split(/W+/)[0]} on conceptnet`);

    let start = '/c/en/' + startConcept.toLowerCase().replace(' ', '_');
    let end = '/c/en/' + endConcept.toLowerCase().replace(' ', '_');

    let searchType = getAllPaths ? 'allShortestPaths' : 'shortestPath';
    let nodeWithStartId = '(a:Concept {id: {start} })';
    let nodeWithEndId = '(b:Concept {id: {end} })';
    let pathRange = '[*0..6]';
    let resultPromise = session.run(
        `MATCH path=${searchType}(${nodeWithStartId}-${pathRange}-${nodeWithEndId}) RETURN path`, {
            'start': start,
            'end': end,
        }
    );

    resultPromise.then((result) => {
        session.close();

        let records = result.records;
        let paths = [];
        let pathStrs = [];
        for (let recordIndex = 0; recordIndex < records.length; recordIndex++) {
            let segments = records[recordIndex]._fields[0].segments;
            let pathStr = '';
            paths.push([]);

            for (let i = 0; i < segments.length; i++) {
                let segment = segments[i];

                let segmentStart = parseElement(segment.start.properties.id);
                let relationship = parseElement(segment.relationship.properties.type);
                let segmentEnd = parseElement(segment.end.properties.id);

                let segmentStartIdentity = segment.start.identity;
                let relationshipStartIdentity = segment.relationship.start;
                let isTowardsEnd = relationshipStartIdentity === segmentStartIdentity;

                if (i == 0) {
                    paths[recordIndex].push(segmentStart);
                    pathStr += segmentStart;
                }
                pathStr += isTowardsEnd ? ' <--' : ' --';
                pathStr += relationship;
                pathStr += isTowardsEnd ? '-- ' : '--> ';
                pathStr += segmentEnd;

                paths[recordIndex].push(relationship);
                paths[recordIndex].push(segmentEnd);
            }
            console.log(pathStr);
            pathStrs.push(pathStr);
        }
        console.log(paths);

        // on application exit:
        driver.close();
        callback(paths);
    });

    /**
     * given a string,
     * such as /c/en/concept/n or /r/relation/
     * gets the name of the concept or relation
     * @param {String} str
     * @return {String}
     */
    function parseElement(str) {
        const elementInfo = str.split('/');
        return elementInfo[1] === 'r' ? elementInfo[2] : elementInfo[3];
    }
}

/**
 * gets fakes paths between the given two concepts and calls the given callback
 * @param {String} startConcept phrase to start with
 * @param {String} endConcept phrase to end
 * @param {Function} callback function to call when done
 */
export function getTestPathBetweenConcepts(startConcept, endConcept, callback) {
    callback([
        [
            startConcept, 'testRelation', 'testNode', 'testRelation',
            'testNode', 'testRelation', endConcept,
        ],
        [
            startConcept, 'testRelation', 'testNode', 'testRelation',
            'testNode', 'testRelation', 'testNode', 'testRelation', endConcept,
        ],
        [
            startConcept, 'testRelation', 'testNode',
            'testRelation', endConcept,
        ],
    ]);
}

export default {
    getPathBetweenConcepts,
    getTestPathBetweenConcepts,
};
